import * as routeNames from '@/shared/router/route-names'

export default [
  {
    path: '/',
    redirect: 'billRequest'
  },
  {
    path: '/billRequest',
    name: routeNames.BILLREQUEST,
    component: () => import('@/views/apps/requisition/billRequest')
  },
  {
    path: '/billPending',
    name: routeNames.BILLPENDING,
    component: () => import('@/views/apps/requisition/billPending')
  },
  {
    path: '/billAlready',
    name: routeNames.BILLALREADY,
    component: () => import('@/views/apps/requisition/billAlready')
  },
  {
    path: '/billSponsor',
    name: routeNames.BILLSPONSOR,
    component: () => import('@/views/apps/requisition/billSponsor')
  },
  {
    path: '/billCopy',
    name: routeNames.BILLCOPY,
    component: () => import('@/views/apps/requisition/billCopy')
  },
  {
    path: '/billAll',
    name: routeNames.BILLALL,
    component: () => import('@/views/apps/requisition/billAll')
  }
]
